import * as React from "react";

export const NotClientIcon = (props: any) => (
  <svg
    width={28}
    height={28}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={28} height={28} rx={14} fill="#fff" />
    <path
      d="m8.375 6.375 2.676 6.465a5.508 5.508 0 0 0-1.934 2.012 5.502 5.502 0 0 0-.742 2.793c0 1.002.254 1.94.762 2.812a5.834 5.834 0 0 0 2.031 2.031A5.533 5.533 0 0 0 14 23.25c1.016 0 1.96-.254 2.832-.762a5.834 5.834 0 0 0 2.031-2.031c.508-.872.762-1.81.762-2.813a5.502 5.502 0 0 0-.742-2.792 5.404 5.404 0 0 0-1.914-1.993l2.656-6.484h-1.348l-2.441 5.938c-.43-.144-.86-.241-1.29-.293l2.325-5.645h-1.348l-2.343 5.684a5.27 5.27 0 0 0-1.016.254L9.723 6.375H8.375Zm2.754 0 1.601 3.867.665-1.66-.918-2.207h-1.348ZM14 13.25c.794 0 1.523.195 2.188.586.677.39 1.21.924 1.601 1.601.39.665.586 1.394.586 2.188a4.34 4.34 0 0 1-.586 2.207 4.343 4.343 0 0 1-1.602 1.582A4.236 4.236 0 0 1 14 22a4.34 4.34 0 0 1-3.79-2.168 4.34 4.34 0 0 1-.585-2.207c0-.794.195-1.523.586-2.188.39-.677.918-1.21 1.582-1.601A4.34 4.34 0 0 1 14 13.25Zm0 1.973-.723 1.64-1.777.196 1.328 1.191-.371 1.758L14 19.109l1.543.899-.371-1.758 1.328-1.191-1.777-.196-.723-1.64Z"
      fill="#646363"
    />
  </svg>
);
